// Single source for the public support address (STUD-533). The backend alert
// mailer (learner-app-server/utils/mailer.js) defaults to the same mailbox.
export const SUPPORT_EMAIL = 'support@testcoachai.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
